import { Container } from '../components/container';
import { Columns, Column } from '../components/columns';
import { AnimatedText } from '../components/animated-text';
import { Vine } from '../components/vine';
import { useVisibleDelay } from '../hooks/use-delay';
import { Hero } from '../components/hero';

export default function TrusteesStaff(props) {
  const [ref, animateIntroSection] = useVisibleDelay();

  return (
    <>
      <Hero />
      <article className="page narrow">
        <Container className="pb0">
          <Columns>
            <Column className="one-third-ish">
              <h1 ref={ref} className="undervine">
                <span>
                  <AnimatedText isVisible={animateIntroSection}>
                    Trustees _ and Staff
                  </AnimatedText>
                  {animateIntroSection && <Vine />}
                </span>
              </h1>
            </Column>

            <Column className="two-thirds-ish">
              <p>
                The Northland Foundation is guided by a diverse{' '}
                <a
                  href="https://northlandfdn.org/about-us/staff-board-contact.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Board of Trustees
                </a>{' '}
                from across our service area, and our{' '}
                <a
                  href="https://northlandfdn.org/about-us/staff-board-contact.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  staff team
                </a>{' '}
                carries out the ongoing work of the foundation. An Emeritus
                Trustee Group made up of our former Trustees and President stays
                connected and supports our mission. The{' '}
                <a
                  href="https://northlandfdn.org/special-initiatives/maada-ookiing-indigenous-led.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Maada’ookiing Board
                </a>{' '}
                provides oversight for our new Indigenous-led program. We thank
                all these individuals for their dedication.
              </p>
            </Column>
          </Columns>
        </Container>

        <Container>
          <h2 className="h3 undervine">
            <span>
              2020-2021 Board of Trustees
              <Vine />
            </span>
          </h2>

          <Columns count="3">
            <p>
              <strong>
                Jason Hollinday, Chair
                <br />
              </strong>
              Director of Planning
              <br />
              Fond du Lac Band of Lake Superior Chippewa
              <br />
              Duluth
            </p>
            <p>
              <strong>Shaye Moris, Vice Chair</strong>
              <br />
              Executive Director
              <br />
              Second Harvest Northern Lakes <br />
              Food Bank
              <br />
              Duluth
            </p>
            <p>
              <strong>Peter McDermott, Treasurer</strong>
              <br />
              President/CEO (retired)
              <br />
              Minnesota Diversified Industries, Inc.
              <br />
              Grand Rapids
            </p>
            <p>
              <strong>Cindy Anderson Bina, Secretary</strong>
              <br />
              Counselor (retired)
              <br />
              Vermilion Community College
              <br />
              Ely
            </p>
            <p>
              <strong>Baabiitaw Boyd</strong>
              <br />
              Sr. Advisor on Objibwe Language Revitalization Initiatives
              <br />
              Mille Lacs Band of Ojibwe
              <br />
              Garrison
            </p>
            <p>
              <strong>Mary Harrelson </strong>
              <br />
              Licensed Psychologist
              <br />
              Mary Rademacher Psychological Services
              <br />
              Grand Portage Reservation
            </p>
            <p>
              <strong>Trent Janezich, Ed.D., Immediate Past Chair</strong>
              <br />
              Executive Director, Advanced Minnesota
              <br />
              Minnesota State
              <br />
              Hibbing
            </p>

            <p>
              <strong>Lisa Kruse</strong>
              <br />
              Education Coordinator
              <br />
              Riverwood Healthcare Center
              <br />
              Tamarack
            </p>
            <p>
              <strong>Angie Miller</strong>
              <br />
              Executive Director (retired)
              <br />
              Community Action Duluth
              <br />
              Duluth
            </p>
            <p>
              <strong>Lori Rothstein</strong>
              <br />
              Leadership and Civic Engagement Educator
              <br />
              University of Minnesota Extension
              <br />
              Grand Marais
            </p>
            <p>
              <strong>Sumair Sheikh</strong>
              <br />
              Literacy Instructional Coach
              <br />
              Cloquet Public Schools ISD #94
              <br />
              Duluth
            </p>
            <p>
              <strong>Roy Smith</strong>
              <br />
              Director of Education and Talent Development
              <br />
              Iron Range Resources/Minnesota State Colleges & Universities
              <br />
              Hibbing
            </p>
          </Columns>
        </Container>

        <Container isDark>
          <h2 className="h3 undervine">
            <span>
              Emeritus Trustee Group
              <Vine />
            </span>
          </h2>

          <Columns count="3">
            <p>
              <strong>Phil Anderson</strong>
            </p>
            <p>
              <strong>Lisa Bodine</strong>
            </p>
            <p>
              <strong>Dave Clusiau</strong>
            </p>
            <p>
              <strong>Jeff Corey</strong>
            </p>
            <p>
              <strong>Eddie Crawford</strong>
            </p>
            <p>
              <strong>Steve Downing</strong>
            </p>
            <p>
              <strong>Lynn Goerdt</strong>
            </p>
            <p>
              <strong>Bill Hansen</strong>
            </p>
            <p>
              <strong>Cindy Hansen</strong>
            </p>
            <p>
              <strong>Edwina Hertzberg</strong>
            </p>
            <p>
              <strong>Mary Ives</strong>
            </p>
            <p>
              <strong>Ken Johnson</strong>
            </p>
            <p>
              <strong>Lisa Kruse</strong>
            </p>
            <p>
              <strong>Nevada Littlewolf</strong>
            </p>
            <p>
              <strong>Scott Martin</strong>
            </p>
            <p>
              <strong>Antoinette Monster</strong>
            </p>
            <p>
              <strong>Nancy Norr</strong>
            </p>
            <p>
              <strong>Mark Phillips</strong>
            </p>
            <p>
              <strong>Allen Rasmussen</strong>
            </p>
            <p>
              <strong>Diane Rauschenfels</strong>
            </p>
            <p>
              <strong>Tom Renier, President Emeritus</strong>
            </p>
            <p>
              <strong>Tom Rider</strong>
            </p>
            <p>
              <strong>Joe Sertich</strong>
            </p>
            <p>
              <strong>Chuck Walt</strong>
            </p>
            <p>
              <strong>Ed Zabinski</strong>
            </p>
          </Columns>
        </Container>

        <Container>
          <h2 className="h3 undervine">
            <span>
              Northland Foundation Staff
              <Vine />
            </span>
          </h2>

          <Columns count="3">
            <p>
              <strong>Jan Amys</strong>
              <br />
              Senior Program Officer
            </p>
            <p>
              <strong>Zane Bail</strong>
              <br />
              Chief Operating Officer
            </p>
            <p>
              <strong>Heather Brouse</strong>
              <br />
              Chief Financial Officer
            </p>
            <p>
              <strong>Carol Chipman</strong>
              <br />
              Grants Manager
            </p>
            <p>
              <strong>Michael Colclough</strong>
              <br />
              Business Services Director
            </p>
            <p>
              <strong>Jeanine Dahl</strong>
              <br />
              Communications Director
            </p>
            <p>
              <strong>Vicki Hagberg</strong>
              <br />
              SBDC Associate Director
            </p>
            <p>
              <strong>Lynn Haglin</strong>
              <br />
              Vice President/KIDS PLUS Director
              <br />(<em>retired June 2021)</em>
            </p>
            <p>
              <strong>LeAnn Littlewolf</strong>
              <br />
              Senior Program Officer
            </p>
            <p>
              <strong>Mary Lundeen</strong>
              <br />
              Business Consultant
            </p>
            <p>
              <strong>Betsy Olivanti</strong>
              <br />
              Business Consultant
            </p>
            <p>
              <strong>Suzanne Rauvola</strong>
              <br />
              Systems Manager
            </p>
            <p>
              <strong>Carole Saylor</strong>
              <br />
              Executive Administrator
              <br />
              to President and Board
            </p>
            <p>
              <strong>Sandy Scheiber</strong>
              <br />
              Program Assistant
            </p>
            <p>
              <strong>Tony Sertich</strong>
              <br />
              President/CEO
            </p>
            <p>
              <strong>Lisa Shrum</strong>
              <br />
              Accounting Clerk
            </p>
            <p>
              <strong>Erik Torch</strong>
              <br />
              Director of Grantmaking
            </p>
            <p>
              <strong>Curt Walczak</strong>
              <br />
              Business Consultant
            </p>
            <p>
              <strong>Julie Weisgerber</strong>
              <br />
              Program Associate
            </p>
          </Columns>
        </Container>
      </article>
    </>
  );
}
